import React from 'react'

import { CustomTheme, B2CCard, DottedDivider } from '@masfront/common-b2c'

import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { formatAddress, getEmailFromCustomer } from '~/customer/helpers/customer.helpers'
import useCustomer from '~/customer/useCustomer'
import LineItem from '~/ui/components/LineItem/LineItem'

const useStyles = makeStyles((theme: CustomTheme) => {
  return {
    lineItem: {
      marginBottom: theme.spacing(5),
    },
  }
})

const ContactCard: React.FC = () => {
  const { customer } = useCustomer()
  const classes = useStyles()

  return (
    <B2CCard title="Contacto" dataHookPrefix="contact">
      {customer && (
        <>
          <LineItem
            dataHook="customer-contact-address"
            className={classes.lineItem}
            primaryText="Dirección"
            secondaryText={formatAddress(customer.addressInfo)}
            vertical
          />
          <LineItem
            dataHook="customer-contact-email"
            className={classes.lineItem}
            primaryText="Email"
            secondaryText={getEmailFromCustomer(customer) || '-'}
            vertical
          />

          <DottedDivider />
          <Box m={3} />

          <LineItem
            dataHook="customer-contact-phone"
            className={classes.lineItem}
            primaryText="Teléfono"
            secondaryText={
              (customer.business ? customer.business.otherPhone : customer.personal?.otherPhone) ||
              '-'
            }
            vertical
          />
        </>
      )}
    </B2CCard>
  )
}

export default ContactCard
